import update from 'immutability-helper';
import { AnyAction, Dispatch } from 'redux';

import doLoadRouteImports from '../services/loadRouteImports';

// Actions
const START_LOAD = 'routeImport/routeImports/START_LOAD';
const COMPLETE_LOAD = 'routeImport/routeImports/COMPLETE_LOAD';
const FAIL_LOAD = 'routeImport/routeImports/FAIL_LOAD';
const RESET = 'routeImport/routeImports/RESET';

// Initial state
const initialState = {
  isLoading: false,
  routeImports: undefined,
};

// Reducer
export const reducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case START_LOAD:
      return update(state, {
        $merge: {
          isLoading: true,
        },
      });

    case COMPLETE_LOAD:
      return update(state, {
        $merge: {
          isLoading: false,
          routeImports: action.routeImports,
        },
      });

    case FAIL_LOAD:
      return update(state, {
        $merge: {
          isLoading: false,
          routeImports: undefined,
        },
      });

    case RESET:
      return initialState;

    default:
      return state;
  }
};

// Action creators
const startLoad = () => ({
  type: START_LOAD,
});

const completeLoad = (routeImports: any) => ({
  type: COMPLETE_LOAD,
  routeImports,
});

const failLoad = () => ({
  type: FAIL_LOAD,
});

export const loadRouteImports = (
  vendorId: number,
  fileProcessingStatusTypeId: number,
  startDate: string,
  endDate: string,
) => (dispatch: Dispatch) => {
  dispatch(startLoad());

  const loadRouteImportsPromise = doLoadRouteImports(vendorId, fileProcessingStatusTypeId, startDate, endDate);

  loadRouteImportsPromise.then(routeImports => dispatch(completeLoad(routeImports))).catch(() => dispatch(failLoad()));

  return loadRouteImportsPromise;
};

export const resetRouteImports = () => ({
  type: RESET,
});
